import { render } from "./Q6Detaille.vue?vue&type=template&id=35f79757"
import script from "./Q6Detaille.vue?vue&type=script&lang=js"
export * from "./Q6Detaille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__